import { jsxs, jsx } from 'react/jsx-runtime';
import '../../pill/pill/index.esm.js';
import { EGDSRemovablePill } from '../../pill/removable-pill/index.esm.js';
import '../../pill/trigger-pill/index.esm.js';
import '../../pill/pill-container/index.esm.js';
import { EGDSButtonSize } from '../../button/button/index.esm.js';
import 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSTertiaryButton } from '../../button/tertiary-button/index.esm.js';
import '../../button/paging-button/index.esm.js';
import { useLocalization } from '@shared-ui/localization-context';
import styles from '../../styles/uitk-egds-typeahead.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { liveAnnounce } from '../../utils/live-announce/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSTypeaheadSelections = props => {
  const {
    headingText,
    hideHeading = false,
    typeaheadLabel,
    stid = '',
    values = [],
    /* eslint-disable @typescript-eslint/no-empty-function */
    onItemRemove = () => {},
    /* eslint-disable @typescript-eslint/no-empty-function */
    onClear = () => {},
    clearAllText,
    className,
    multiSelectClearAll,
    multiSelectSelectedItemHeading,
    removeSelection,
    clearAllSelections
  } = props;
  const l10n = useLocalization();
  const clearAll = clearAllText ?? multiSelectClearAll ?? l10n.formatText('typeahead.mulselect.clearAll');
  const heading = headingText ?? multiSelectSelectedItemHeading ?? l10n.formatText('typeahead.multiselect.selectedItemHeading');
  const handleRemove = (value, index) => {
    liveAnnounce(removeSelection ?? l10n.formatText('typeahead.removeSelection', value));
    onItemRemove(index);
  };
  const handleClear = () => {
    liveAnnounce(clearAllSelections ?? l10n.formatText('typeahead.clearAllSelections', typeaheadLabel));
    onClear();
  };
  return jsxs("div", {
    className: getClassNameList('uitk-typeahead-selections', className),
    children: [!hideHeading && heading && values.length > 0 ? jsx("div", {
      className: getClassNameList('uitk-typeahead-result-title-label', 'truncate'),
      children: heading
    }) : null, jsxs("div", {
      className: getClassNameList('uitk-typeahead-pills'),
      "data-stid": stid,
      children: [(Array.isArray(values) ? values : [values]).map((value, index) => jsx(EGDSRemovablePill, {
        onClick: () => handleRemove(value, index),
        id: `${stid}-pill-${index}`,
        className: getClassNameList('uitk-typeahead-pill-removable'),
        children: value
      }, `${stid}-pill-${index}`)), values.length ? jsx(EGDSTertiaryButton, {
        onClick: handleClear,
        size: EGDSButtonSize.SMALL,
        children: clearAll
      }) : null]
    })]
  });
};
export { EGDSTypeaheadSelections };